import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { Session } from "../utils/session";

export default function Imesheet() {

  const navigate = useNavigate();
  const location = useLocation();
  const { sheetName, workspaceId } = location.state || {};

  const [showModal, setShowModal] = useState(true);
  const [tabs, setTabs] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [selectedTab, setSelectedTab] = useState("");
  const [users, setUsers] = useState([]);

  
useEffect(() => {

  if (!location.state?.fromAddCard) {
    navigate("/dailytask");
  }

}, [location.state, navigate]);

  const [form, setForm] = useState({
    doctorName: "",
    date: "",
    claimant: "",
    vendor: "",
    pageNo: "",
    extractionUser: "",
    show: "",
    rorUser: "",
    templateUser: "",
    imeForms: "",
    qcUser: "",
    comments1: "",
    comments2: "",
    extractionAssignTime: "",
    extractionDoneTime: "",
    rorAssignTime: "",
    rorDoneTime: "",
    templateAssignTime: "",
    templateDoneTime: "",
    qcAssignTime: "",
    qcDoneTime: "",
    extractionDescription: "",
    rorDescription: "",
    templateDescription: "",
     qcDescription: "",
  });


  useEffect(() => {

    if (!sheetName) return;

    fetch(
      `${API_BASE_URL}/api/GoogleSheet/tabs?sheetName=${encodeURIComponent(sheetName)}`,
      {
        headers: {
          Authorization: `Bearer ${Session.getToken()}`
        }
      }
    )
      .then(res => res.json())
      .then(data => setTabs(Array.isArray(data) ? data : []))
      .catch(err => console.error("Tab load error:", err));

  }, [sheetName]);

  useEffect(() => {
  fetch(`${API_BASE_URL}/api/Members/Users_List?workspaceName=IME`, {
    headers: {
      Authorization: `Bearer ${Session.getToken()}`
    }
  })
    .then(res => res.json())
    .then(data => setUsers(Array.isArray(data) ? data : []))
    .catch(err => console.error("Users load error:", err));
}, []);


  useEffect(() => {

    fetch(`${API_BASE_URL}/api/GoogleSheet/doctors-list`, {
      headers: {
        Authorization: `Bearer ${Session.getToken()}`
      }
    })
      .then(res => res.json())
      .then(data => setDoctors(Array.isArray(data) ? data : []))
      .catch(err => console.error("Doctor load error:", err));

  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => document.body.style.overflow = "auto";
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const closeModal = () => {
    setShowModal(false);
    navigate(-1);
  };

 const handleSave = async () => {

  if (!selectedTab) {
    alert("Please Select Tab ❗");
    return;
  }

  if (!form.claimant) {
    alert("Claimant Required ❗");
    return;
  }
const getUserName = (id) => {
  const u = users.find(x => String(x.userId) === String(id));
  return u ? u.userName : null;
};

const extractionName = getUserName(form.extractionUser);
const rorName = getUserName(form.rorUser);
const templateName = getUserName(form.templateUser);
const qcName = getUserName(form.qcUser);

  const payload = {

    DoctorName: form.doctorName || null,
    Date: form.date || null,
    Claimant: form.claimant || null,
    Vendor: form.vendor || null,
    PageNo: form.pageNo || null,
    ExtractionUser: form.extractionUser
  ? Number(form.extractionUser)
  : null,

RORuser: form.rorUser
  ? Number(form.rorUser)
  : null,

Templateuser: form.templateUser
  ? Number(form.templateUser)
  : null,

QCuser: form.qcUser
  ? Number(form.qcUser)
  : null,


ExtractionUserName: extractionName,
RORuserName: rorName,
TemplateuserName: templateName,
QCuserName: qcName,
    Show: form.show || null,
    IMEForms: form.imeForms || null,
    Comments1: form.comments1 || null,
    Comments2: form.comments2 || null,
    ExtractionAssignTimestamp: form.extractionAssignTime || null,
    ExtractionDoneTimestamp: form.extractionDoneTime || null,
    RORuserAssignTimestamp: form.rorAssignTime || null,
    RORDoneTimestamp: form.rorDoneTime || null,
    TemplateuserAssignTimestamp: form.templateAssignTime || null,
    TemplateDoneTimestamp: form.templateDoneTime || null,
    QCuserAssignTimestamp: form.qcAssignTime || null,
    QCDoneTimestamp: form.qcDoneTime || null,
    WorkspaceID: Number(workspaceId),
    TabName: selectedTab,
    SheetName: sheetName,
    ExtractionDescription: form.extractionDescription || null,
    RORDescription: form.rorDescription || null,
    TemplateDescription: form.templateDescription || null,
    QCDescription: form.qcDescription || null,
  };

  try {

    const res = await fetch(`${API_BASE_URL}/api/Cards/create-IME`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Session.getToken()}`
      },
      body: JSON.stringify(payload)
    });

    const result = await res.text();
    console.log("API Response:", result);

    if (!res.ok) {
      throw new Error(result);
    }

    alert("Saved Successfully ✅");

    closeModal();

  } catch (err) {
    console.error("Save Error:", err);
    alert("Save Failed ❌\n" + err.message);
  }
};

  if (!showModal) return null;

  return (
    <>
  
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header bg-light">
              <h5 className="fw-bold">Add IME Sheet</h5>

              <button
                className="btn-close"
                onClick={closeModal}
              ></button>
            </div>

            {/* BODY */}
        <div className="modal-body">

  <div className="row g-3">

    {/* TAB */}
    <div className="col-md-6">
      <label>Sheet Tab</label>
      <select
        className="form-select"
        value={selectedTab}
        onChange={(e) => setSelectedTab(e.target.value)}
      >
        <option value="">Select Tab</option>
        {tabs.map((t, i) => (
          <option key={i} value={t}>{t}</option>
        ))}
      </select>
    </div>

    {/* DOCTOR */}
    <div className="col-md-6">
      <label>Doctor Name</label>
      <select
        className="form-select"
        name="doctorName"
        value={form.doctorName}
        onChange={handleChange}
      >
        <option value="">Select Doctor</option>
        {doctors.map((d, i) => (
          <option key={i} value={d}>{d}</option>
        ))}
      </select>
    </div>

    {/* DATE */}
    <div className="col-md-6">
      <label>Date</label>
      <input
        type="date"
        className="form-control"
        name="date"
        value={form.date}
        onChange={handleChange}
      />
    </div>

    {/* CLAIMANT */}
    <div className="col-md-6">
      <label>Claimant</label>
      <input
        className="form-control"
        name="claimant"
        value={form.claimant}
        onChange={handleChange}
      />
    </div>

    {/* VENDOR */}
    <div className="col-md-6">
      <label>Vendor</label>
      <input
        className="form-control"
        name="vendor"
        value={form.vendor}
        onChange={handleChange}
      />
    </div>

    {/* PAGE */}
    <div className="col-md-6">
      <label>Page No</label>
      <input
        type="text"
        className="form-control"
        name="pageNo"
        value={form.pageNo}
        onChange={handleChange}
      />
    </div>

    {/* EXTRACTION USER */}
  <div className="col-md-6">
  <label>Extraction User</label>

  <select
    className="form-select"
    name="extractionUser"
    value={form.extractionUser}
    onChange={handleChange}
  >
    <option value="">Select EXTRACTION User</option>

    {users.map(u => (
      <option key={u.userId} value={u.userId}>
        {u.userName}
      </option>
    ))}
  </select>
</div>



    {/* SHOW / NO SHOW */}
   <div className="col-md-6">
  <label>Show / No Show</label>

  <input
    type="checkbox"
    className="form-check-input ms-2"
    name="show"
    checked={form.show}
    onChange={handleChange}
  />
</div>


    {/* ROR USER */}
 <div className="col-md-6">
  <label>ROR User</label>

  <select
    className="form-select"
    name="rorUser"
    value={form.rorUser}
    onChange={handleChange}
  >
    <option value="">Select ROR User</option>

    {users.map(u => (
      <option key={u.userId} value={u.userId}>
        {u.userName}
      </option>
    ))}
  </select>
</div>


    {/* TEMPLATE USER */}
  <div className="col-md-6">
  <label>Template User</label>

  <select
    className="form-select"
    name="templateUser"
    value={form.templateUser}
    onChange={handleChange}
  >
    <option value="">Select TEMPLATE User</option>

    {users.map(u => (
      <option key={u.userId} value={u.userId}>
        {u.userName}
      </option>
    ))}
  </select>
</div>


    {/* IME FORMS */}
    <div className="col-md-6">
      <label>IME Forms</label>
      <input
        className="form-control"
        name="imeForms"
        value={form.imeForms}
        onChange={handleChange}
      />
    </div>

    {/* QC USER */}
  <div className="col-md-6">
  <label>QC User</label>

  <select
    className="form-select"
    name="qcUser"
    value={form.qcUser}
    onChange={handleChange}
  >
    <option value="">Select QC User</option>

    {users.map(u => (
      <option key={u.userId} value={u.userId}>
        {u.userName}
      </option>
    ))}
  </select>
</div>



    {/* COMMENTS 1 */}
    <div className="col-md-6">
      <label>Comments</label>
      <textarea
        className="form-control"
        name="comments1"
        value={form.comments1}
        onChange={handleChange}
      />
    </div>

    {/* COMMENTS 2 */}
    <div className="col-md-6">
      <label>Extra Comments</label>
      <textarea
        className="form-control"
        name="comments2"
        value={form.comments2}
        onChange={handleChange}
      />
    </div>

<div className="col-md-6">
  <label>Extraction Description</label>
  <textarea
    className="form-control"
    name="extractionDescription"
    value={form.extractionDescription}
    onChange={handleChange}
  />
</div>

<div className="col-md-6">
  <label>ROR Description</label>
  <textarea
    className="form-control"
    name="rorDescription"
    value={form.rorDescription}
    onChange={handleChange}
  />
</div>

<div className="col-md-6">
  <label>Template Description</label>
  <textarea
    className="form-control"
    name="templateDescription"
    value={form.templateDescription}
    onChange={handleChange}
  />
</div>
<div className="col-md-6">
  <label>QC Description</label>
  <textarea
    className="form-control"
    name="qcDescription"
    value={form.qcDescription}
    onChange={handleChange}
  />
</div>
  </div>

</div>


            {/* FOOTER */}
            <div className="modal-footer bg-light">

              <button
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={handleSave}
              >
                Save
              </button>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}
